import script from "./SideBarFolding.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarFolding.vue?vue&type=script&setup=true&lang=js"

import "./SideBarFolding.vue?vue&type=style&index=0&id=c2b22fe0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b22fe0"]])

export default __exports__